import React from 'react';
import { forgotPassword } from '../api/appApi';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

const ForgotPassword = () => {
  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Email is required'),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const res = await forgotPassword(values.email);
      Swal.fire({ icon: 'success', title: 'Reset Link Sent', text: res.message || 'If this email exists, a reset link will be sent.' });
      resetForm();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed to send reset link.' });
    }
    setSubmitting(false);
  };

  return (
    <div className="row min-vh-100 g-0">
      <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center auth-banner-bg forgot-banner-bg"></div>
      <div className="col-12 col-md-6 d-flex align-items-center justify-content-center">
        <Formik
          initialValues={{ email: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form className="w-50">
              <h2 className="mb-4 form-title text-center">FORGOT PASSWORD?</h2>
              <h4 className="mb-4 reset-title text-center">Enter Email ID to receive password reset link</h4>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <Field type="email" name="email" className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`} id="email" placeholder="Enter Email ID" />
                <div className="form-text text-danger"><ErrorMessage name="email" /></div>
              </div>
              <button type="submit" className="btn btn-primary w-100 submit-btn" disabled={isSubmitting}>Get Link</button>
              <div className="mt-3 text-center">
                <label className="form-label"><a href="/login">Back to Login</a></label>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgotPassword;
